<template>
    <b-input-group :class="{'is-invalid': !valid}" :size="size">
        <b-input-group-prepend>
            <b-form-datepicker v-model="newValue"
                               :disabled="disabled"
                               v-bind="datePickerOptions"
                               :size="size"
                               button-only
                               reset-button
            />
        </b-input-group-prepend>
        <b-form-input :value="displayDateFormat(value)"
                      :disabled="disabled"
                      :state="disabled ? undefined : valid"
                      @keyup="setDateFromInput($event)"
                      @blur="checkDateValue($event)"
                      :placeholder="placeholder"
        />
    </b-input-group>
</template>
<script>
    import { dateToFormat } from '@/filters'
    import datePickerOptions from '@/helpers/date-picker-options'

    export default {
        name: "InputDatePicker",
        props: {
            valid: {},
            value: {},
            disabled: {},
            size: {},
            placeholder: {
                default: 'Дата не выбрана'
            }
        },
        data() {
            return {
                datePickerOptions: datePickerOptions,
                newValue: this.value
            }
        },
        watch: {
            newValue() {
                this.$emit('input', this.newValue)
            }
        },
        methods: {
            displayDateFormat(dateStr) {
                return dateToFormat(dateStr, 'dd.MM.yyyy')
            },
            setDateFromInput(event) {
                if (event.target.value.length >= 10) {
                    this.newValue = dateToFormat(event.target.value, 'yyyy-MM-dd') ?? null
                    event.target.value = this.displayDateFormat(event.target.value)
                }
            },
            checkDateValue(event) {
                this.newValue = dateToFormat(event.target.value, 'yyyy-MM-dd') ?? null
                event.target.value = this.displayDateFormat(event.target.value)
            }
        }
    }
</script>
